import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = { class: "successful-payment" };
var _hoisted_2 = { class: "successful-payment__notify" };
var _hoisted_3 = { class: "successful-payment__header" };
var _hoisted_4 = { class: "successful-payment__title" };
var _hoisted_5 = {
    key: 0,
    class: "successful-payment__subtitle"
};
import { Close } from '@element-plus/icons-vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SuccessfulPayment',
    props: {
        target: {
            type: String,
            required: true
        }
    },
    emits: ['close'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var emit = __emit;
        var closeModal = function () {
            emit('close');
        };
        return function (_ctx, _cache) {
            var _component_el_icon = _resolveComponent("el-icon");
            var _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                            size: "large",
                            link: "",
                            onClick: closeModal
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_el_icon, {
                                    size: 24,
                                    color: "#222222"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_unref(Close))
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.target === 'TARIFF' ? 'Подписка успешно оформлена' : 'Ваш заказ был успешно оплачен'), 1),
                    (__props.target === 'TARIFF')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Вы можете связаться с личным ассистентом в разделе “личный кабинет” "))
                        : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                        class: "successful-payment__button accept-button",
                        color: "#013766",
                        onClick: closeModal
                    }, {
                        default: _withCtx(function () { return _cache[0] || (_cache[0] = [
                            _createTextVNode(" Хорошо ")
                        ]); }),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
